import en from "./locales/en.json";
import ru from "./locales/ru.json";
import uk from "./locales/uk.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";
import sv from "./locales/sv.json";
import da from "./locales/da.json";

export const SUPPORTED_LANGUAGES = [
  "en", "ru", "uk", "es", "de", "fr", "it", "pt", "sv", "da",
] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const resources = {
  en: { translation: en },
  ru: { translation: ru },
  uk: { translation: uk },
  es: { translation: es },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it },
  pt: { translation: pt },
  sv: { translation: sv },
  da: { translation: da },
};
